import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { EbwModalService } from '@ebw-monorepo/modal';
import { lastValueFrom } from 'rxjs';
import { AnteaService } from '../../../../services/antea.service';

@Component({
  selector: 'ebw-monorepo-antea-credentials-dialog',
  templateUrl: './antea-credentials-dialog.component.html',
  styleUrls: ['./antea-credentials-dialog.component.scss']
})
export class AnteaCredentialsDialogComponent {
  public form: FormGroup;
  public submitting = false;

  constructor(
    public dialogRef: MatDialogRef<AnteaCredentialsDialogComponent>,
    private _anteaService: AnteaService,
    private _modalService: EbwModalService
  ) {
    this.form = new FormBuilder().group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
      clientId: ['', [Validators.required]],
      clientSecret: ['', [Validators.required]]
    });
  }

  public async submit(): Promise<void> {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }

    this.submitting = true;
    try {
      await lastValueFrom(this._anteaService.login(this.form.value));
      this.dialogRef.close(true);
    } catch (error: any) {
      this._modalService.openErrorModal({
        title: 'Errore di autenticazione',
        content: error?.error?.message ?? 'Errore durante l\'autenticazione verso AnTeA'
      });
    } finally {
      this.submitting = false;
    }
  }
}
